import * as billingApi from '../api/billing';

/**
 * After an organization's type changes away from Nonprofit, stop its
 * recurring donations (docs/Decisions.md D65 item 5): its payment terms and
 * tax status change, so donors start again under the new entity. Returns a
 * line for the person who made the change, or null when nothing applied.
 * The billing webhook stops any renewal this misses.
 */
export async function afterTypeChange(orgId, fromType, toType) {
  if (fromType !== 'nonprofit' || toType === 'nonprofit') return null;
  try {
    const { halted } = await billingApi.haltRecurringDonations(orgId);
    return halted
      ? `${halted} recurring donation${halted === 1 ? '' : 's'} stopped; donors were told they can start again.`
      : null;
  } catch {
    return 'Recurring donations could not be stopped now; any renewal is stopped when it comes due.';
  }
}

export const NONPROFIT_CHANGE_WARNING =
  'Leaving Nonprofit stops every recurring donation at once. Donors are told and can start again under the new type, because the payment terms and tax status change.';
